import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/components/AuthContext";
import { Seo } from "@/components/Seo";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Tarifs from "@/pages/Tarifs";
import About from "@/pages/About";
import Booking from "@/pages/Booking";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import Faq, { faqs } from "@/pages/Faq";
import AdminLogin from "@/pages/admin/Login";
import Reservations from "@/pages/admin/Reservations";
import AuthCallback from "@/pages/admin/AuthCallback";
import Ville from "@/pages/Ville";
import { villes, findVille } from "@/data/villes";

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const ville = findVille(location.pathname);
  return (
    <>
      <Seo faqs={location.pathname === "/faq" ? faqs : ville?.faqs} ville={ville} />
      <Routes>
      {villes.map((v) => (
        <Route key={v.slug} path={v.path} element={<Ville ville={v} />} />
      ))}
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/tarifs" element={<Tarifs />} />
      <Route path="/a-propos" element={<About />} />
      <Route path="/rendez-vous" element={<Booking />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/reservations" element={<Reservations />} />
    </Routes>
    </>
  );
};

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <AuthProvider>
          <Layout>
            <AppRoutes />
          </Layout>
        </AuthProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
